import {Component, OnInit} from '@angular/core';
import {GebaeudeForm} from './gebaeude.form';
import {EingabeStepComponent} from "../eingabe/eingabe.step.component";

/**
 * Overwrite the Generic step component for the first section fo the stancheck.
 *
 * @inheritDoc
 */
@Component({
    selector: 'app-step-gebaeude',
    templateUrl: '../../step/step.component.html',
    standalone: false
})
export class GebaeudeStepComponent extends EingabeStepComponent implements OnInit {
  /**
   * @inheritDoc
   */
  ngOnInit() {
    // add the correct form config that we need in these steps and init the parent form
    this.formConfig = new GebaeudeForm();
    super.ngOnInit();
  }
}
